import { render } from "./KonsultasiItem.vue?vue&type=template&id=94889e3c"
import script from "./KonsultasiItem.vue?vue&type=script&lang=js"
export * from "./KonsultasiItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__